import { patientActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
};

export const reducer = createReducer(initialState, {
    [patientActions.loadAlRequest]: (state, action) => {
        var al = {
            epno: action.payload.epno,
            ptno: action.payload.ptno,
            loading: true,
            displayMode: -1,
        };
        state[action.payload.epno] = al;
    },
    [patientActions.loadAlSuccess]: (state, action) => {
        state[action.payload.epno].loading = false;
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        var admits = {};

        if (action.payload.patientsContainer.entities.admissions) {
            Object.values(action.payload.patientsContainer.entities.admissions).forEach(x => {
                admits[x.id] = {
                    epno: x.id,
                    ptno: x.ptno,
                    loading: false,
                    displayMode: -1
                };
            });
        }
        state = { ...state, ...admits, ...action.payload.ui.al };
        return state;
    },
    [patientActions.openAlSuccess]: (state, action) => {
        state[action.payload.epno].loading = false;
    },
    [patientActions.closeSuccess]: (state, action) => {
        return Object.values(state).forEach(x => {
            if (x.ptno === action.payload) {
                delete state[x.epno];
            }
        })
    },
    [patientActions.changeAlDisplayMode]: (state, action) => {
        state[action.payload.epno].displayMode = action.payload.mode;
    }




})



